import clsx from 'clsx'

const tones = {
  neutral: 'bg-panel2 text-muted border-line',
  draft: 'bg-warn/10 text-warn border-warn/30',
  published: 'bg-ok/10 text-ok border-ok/30',
  info: 'bg-blue/10 text-sky border-blue/30'
}

export default function Badge({ tone = 'neutral', className, children }) {
  return (
    <span className={clsx(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border',
      tones[tone],
      className
    )}>
      {children}
    </span>
  )
}
